var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center not-found-container"},[_c('i',{staticClass:"ti ti-4x ti-warning"}),_vm._v(" "),_c('h1',[_vm._v("Désolé,")]),_vm._v(" "),_c('p',[_vm._v("La page que vous avez demandée n'existe pas")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Retour à la page d'accueil")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0861e80","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NotFound.vue
// module id = 988
// module chunks = 1